import { TrendingUp, TrendingDown, Minus, MoonStar } from "lucide-react";

export const RISK = {
  stabil: { label: "Stabil", dot: "#10B981", text: "text-emerald-700", bg: "bg-emerald-50", border: "border-emerald-200" },
  beobachten: { label: "Beobachten", dot: "#F59E0B", text: "text-amber-700", bg: "bg-amber-50", border: "border-amber-200" },
  aufmerksamkeit: { label: "Aufmerksamkeit", dot: "#F97316", text: "text-orange-700", bg: "bg-orange-50", border: "border-orange-200" },
  kritisch: { label: "Kritisch", dot: "#EF4444", text: "text-red-700", bg: "bg-red-50", border: "border-red-200" },
};

export function riskCfg(r) {
  return RISK[r] || { label: r || "—", dot: "#94A3B8", text: "text-slate-600", bg: "bg-slate-50", border: "border-slate-200" };
}

export const CONFIDENCE = {
  Hoch: "text-emerald-700",
  Mittel: "text-amber-700",
  Niedrig: "text-slate-500",
};

export function trendIcon(trend) {
  if (trend === "steigend") return { Icon: TrendingUp, cls: "text-emerald-600" };
  if (trend === "sinkend") return { Icon: TrendingDown, cls: "text-red-600" };
  if (trend === "inaktiv") return { Icon: MoonStar, cls: "text-slate-400" };
  return { Icon: Minus, cls: "text-slate-400" };
}

export function healthColor(score) {
  if (score >= 75) return "#10B981";
  if (score >= 55) return "#F59E0B";
  if (score >= 35) return "#F97316";
  return "#EF4444";
}

export function fmtDate(iso, withTime = false) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const opts = withTime
      ? { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }
      : { day: "2-digit", month: "2-digit", year: "numeric" };
    return d.toLocaleDateString("de-DE", opts);
  } catch {
    return "—";
  }
}

export function daysLabel(days) {
  if (days === null || days === undefined) return "—";
  if (days === 0) return "heute";
  if (days === 1) return "vor 1 Tag";
  return `vor ${days} Tagen`;
}

export function fmtEUR(value) {
  if (value === null || value === undefined) return "—";
  try {
    return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(value);
  } catch {
    return `${value} €`;
  }
}

export function revTrendCfg(trend) {
  const map = {
    steigend: { label: "steigend", cls: "text-emerald-600" },
    sinkend: { label: "sinkend", cls: "text-red-600" },
    stabil: { label: "stabil", cls: "text-slate-500" },
    inaktiv: { label: "inaktiv", cls: "text-slate-400" },
  };
  return map[trend] || { label: "—", cls: "text-slate-400" };
}

export const SIGNAL = {
  entwarnung: { label: "Entwarnung", cls: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  warnung: { label: "Warnsignal", cls: "text-red-700 bg-red-50 border-red-200" },
  neutral: { label: "Neutral", cls: "text-slate-600 bg-slate-50 border-slate-200" },
};
